type TypeActionNameWithTo = {
  name: string
  to: string
  icon: string
}

type PortletTitleCrudType = {
  create: TypeActionNameWithTo
  read: TypeActionNameWithTo
  update: TypeActionNameWithTo
  delete: TypeActionNameWithTo
}

const nameEntity = 'MenuFoodType'
const nameSource = 'commercial/menuFoodTypes'
const namePageTitle = 'Refeições'

const nameActionPageMain: TypeActionNameWithTo = {
  name: 'Refeições',
  to: '/commercial/menuFoodTypes',
  icon: ''
}

const nameActions: PortletTitleCrudType = {
  create: {
    name: 'Adicionar',
    to: '/commercial/menuFoodTypes/create/',
    icon: 'fa fa-plus'
  },
  read: {
    name: 'Visualizar',
    to: '/commercial/menuFoodTypes/',
    icon: 'fa fa-list'
  },
  update: {
    name: 'Editar',
    to: '/commercial/menuFoodTypes/update/',
    icon: 'fa fa-edit'
  },
  delete: {
    name: 'Remover',
    to: '#!',
    icon: 'fa fa-remove'
  }
}

export {
  nameEntity,
  nameSource,
  namePageTitle,
  nameActionPageMain,
  nameActions
}
